import OrderIcon from "@/components/orders/OrderIcon";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_ORDERS_URL } from "@/core/urls";
import { ORGANISATION_ORDERS_LIST_QUERY } from "@/graphql/organisations/queries/orders";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import ChevronComponent from "@/tpo/Chevron";
import LinkWrapper from "@/tpo/LinkWrapper";
import ButtonV2 from "@/v2/Buttons";
import { useQuery } from "@apollo/client";

import DashboardPanel from "../DashboardPanel";
import LatestOrdersList from "./LatestOrdersList";
import {
  cmpHomeDashboardListPageSize,
  cmpHomeDashboardPanelPadding,
  cmpHomeDashboardPanelTitleProps,
  cmpHomeDashboardScrollableListBoxProps
} from "./dashboardLayout";

export default function LatestOrdersPanel() {
  const { organisation } = useOrganisationContext();
  const { resolvedUrls } = useCmpRelatedUrl();

  const { data, loading } = useQuery(ORGANISATION_ORDERS_LIST_QUERY, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
    variables: {
      organisation: parseInt(organisation?.id, 10),
      page: 1,
      pageSize: cmpHomeDashboardListPageSize,
      orderBy: "-checkout_date",
      filter: "all"
    },
    skip: !organisation?.id
  });

  const orders = data?.organisationOrdersPagination?.items;

  return (
    <DashboardPanel
      title="Latest orders"
      titleProps={cmpHomeDashboardPanelTitleProps}
      padding={cmpHomeDashboardPanelPadding}
      contentScrollProps={cmpHomeDashboardScrollableListBoxProps}
      headerStart={
        <OrderIcon width={60} iconSize={30} color="#1A1A1A" variant="outline" withCircle />
      }
      headerStartGap={16}
      headerWrap
      headerEnd={
        <ButtonV2
          color="dark"
          size="xs"
          as={LinkWrapper}
          to={resolvedUrls[CMP_ORDERS_URL]}
          rightIcon={<ChevronComponent />}
        >
          view all
        </ButtonV2>
      }
    >
      <LatestOrdersList orders={orders} loading={loading} organisationId={organisation?.hashId} />
    </DashboardPanel>
  );
}
